import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {BillingService} from '../../service/billing/billingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class ReferralProgramGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var referralProgramGrid = this;
		setTimeout(function(){
			referralProgramGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var referralProgramGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
							var status = ElementUtil.query(toolbar, 'status').value;
							if (status === 'A') {
								ElementUtil.query(toolbar, 'activate').classList.add('hide');
							} else {
								ElementUtil.query(toolbar, 'activate').classList.remove('hide');
							}
						}
					}
										
				},				
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_REFERRALS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_REFERRALS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}
				},	
				{
					tag: 'dl-action-button',
					itemid: 'activate',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_REFERRALS:UPDATE_STATUS'],
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Activate')
					],
					listeners: {
						click: function() {							
							actionActivate(grid.selectedItems[0]);
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'delete',
					theme: 'error primary',					
					permissions: ['ADMIN_BILLING_REFERRALS:DELETE'],
					'class': 'spacer-toolbar-item',
					style: 'float: right;',					
					children:[
						ElementUtil.makeIcon('vaadin:close', ' Cancel')
					],
					listeners: {
						click: function() {
							actionCancel(grid.selectedItems[0]);
						}
					}
				}			
			]
		});	
		
		//timing issue on applying the hide
		setTimeout(function() {
			ElementUtil.query(toolbar, 'activate').classList.add('hide');
		}, 100);
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}				
			},			
			children: [	
				{						
					path: 'referralProgram.referralProgramCode',
					header: 'Code',					
					width: '7em'
				},
				{						
					path: 'referralProgram.referralProgramName',
					header: 'Name',					
					width: '7em'
				},
				{						
					path: 'referralProgram.referralProgramDesc',
					header: 'Description',					
					'flex-grow': '1'
				},				
				{						
					path: 'referralPaymentTypeDescription',
					header: 'Payment Type',
					width: '7em',
					'text-align': 'center'
				},						
				{						
					path: 'referralProgram.programApprovedBy',
					header: 'Approved By',
					'text-align': 'center',
					width: '9em'
				},				
				{						
					path: 'referralProgram.updateDts',
					header: 'Update Date',						
					width: '9em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.referralProgram.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}	
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'edit').disabled = false; 						
						ElementUtil.query(toolbar, 'delete').disabled = false;
						ElementUtil.query(toolbar, 'activate').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
						ElementUtil.query(toolbar, 'activate').disabled = true;
					}	
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 200,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					referralProgramGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						status: ElementUtil.query(toolbar, 'status').value	
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;												
						grid.items = records.data;
						
						referralProgramGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					BillingService.getReferralService().getReferralPrograms(referralProgramGrid.currentFilter)
					.then(function(records){							
						successHandler(records);
					});
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});		
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'referral-programs',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'referral-programs.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		referralProgramGrid.append(flexLayout);		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);			
		};
		
		var actionActivate = function(record) {
			var loadMask = grid.showLoading('Activating ' + record.referralProgram.referralProgramCode + '...');	
			BillingService.getReferralService().activateReferralProgram(record.referralProgram.referralProgramCode).then(function(){
				loadMask.remove();
				window.DL.MessageUtil.showToast('Success', 'Activated: ' + record.referralProgram.referralProgramCode, {									
					theme: 'success'
				});
				actionRefresh();
			});	
		};
		
		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add/Edit Referral Program',
				icon: 'lumo:edit',
				listeners: {
					ready: function() {						
						addEditWin.show();
								
						var productItems = [];
						var productItemGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true				
							},			
							children: [	
								{						
									path: 'productCode',
									header: 'Product Code',					
									width: '5em'
								},	
								{						
									path: 'productName',
									header: 'Product name',					
									'flex-grow': '1'
								},	
								{						
									path: 'referralEffDate',
									header: 'Effective Date',					
									width: '9em',
									renderer: function(root, column, rowData) {
										var date = TimeUtil.parseDate(rowData.item.referralEffDate);						
										root.innerHTML = TimeUtil.formatDateStandard(date);						
									}
								},
								{						
									path: 'referralCancelDate',
									header: 'Cancel Date',					
									width: '9em',
									renderer: function(root, column, rowData) {
										if (rowData.item.referralCancelDate) {
											var date = TimeUtil.parseDate(rowData.item.referralCancelDate);						
											root.innerHTML = TimeUtil.formatDateStandard(date);						
										}
									}
								},
								{						
									path: 'referralRewardAmt',
									header: 'Reward Amount',					
									width: '7em',
									renderer: function(root, column, rowData) {
										root.innerHTML = StringUtil.currencyFormat(rowData.item.referralRewardAmt);
									}
								},	
								{
									path: 'referralRewardType',
									header: 'Reward Type',					
									width: '7em'
								},
								{
									path: 'referralDurationAmt',
									header: 'Duration',					
									width: '5em',
									'text-align': 'center'
								},
								{
									path: 'referralDurationUom',
									header: 'Duration Units',					
									width: '5em',
									'text-align': 'center'
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									productItemGrid.selectedItems = item ? [item] : [];
									if (productItemGrid.selectedItems.length > 0) {																
										ElementUtil.query(formPanel, 'remove').disabled = false;
									} else {																
										ElementUtil.query(formPanel, 'remove').disabled = true;
									}	
								}
							}
						});			
								
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [										
										{
											tag: 'vaadin-text-field',
											label: 'Code',
											name: 'referralProgramCode',
											required: true,
											maxlength: 20
										},	
										{
											tag: 'vaadin-text-field',
											label: 'Name',
											name: 'referralProgramName',											
											required: true,
											maxlength: 255
										},
										{
											tag: 'vaadin-text-field',
											label: 'Description',
											name: 'referralProgramDesc',
											required: true,
											maxlength: 1024
										},
										{
											tag: 'vaadin-text-field',
											label: 'Approved By',
											required: true,
											name: 'programApprovedBy',											
											maxlength: 120
										},										
										{
											tag: 'vaadin-combo-box',											
											label: 'Reference Company', 
											name: 'refCompanyId',
											required: true,											
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {
												BillingService.getReferenceCompanyService().getReferenceCompanies().then(function(dataResponse){
													var lookups = [];
													dataResponse.data.forEach(function(reference){
														lookups.push({
															code: reference.refCompanyId,
															description: reference.companyName
														});
													});
													
													combo.items = lookups;
												});
											}
										},										
										{
											tag: 'vaadin-combo-box',											
											label: 'Payment Type', 
											name: 'referralPaymentType',
											required: true,											
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('ReferralPaymentType').then(function(data){
													combo.items = data;
												});
											}
										},
										{
											tag: 'dl-section-title',
											title: 'Program Products',
											colspan: 2
										},							
										{
											tag: 'div',
											style: 'height: 300px',
											colspan: 2,
											children: [
												{
													tag: 'dl-flex-layout',
													children: [
														{
															tag: 'dl-toolbar',
															slot: 'toolbar',
															theme: 'spacing',
															children: [																				
																{
																	tag: 'vaadin-button',
																	itemid: 'add',
																	theme: 'primary',
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:plus', ' Add')
																	],
																	listeners: {
																		click: function() {							
																			actionAddProduct();
																		}
																	}					
																},																						
																{
																	tag: 'vaadin-button',
																	itemid: 'remove',
																	theme: 'error primary',																						
																	'class': 'spacer-toolbar-item',
																	style: 'float: right;',					
																	children:[
																		ElementUtil.makeIcon('vaadin:close', ' Remove')
																	],
																	listeners: {
																		click: function() {
																			actionRemoveProduct(productItemGrid.selectedItems[0]);
																		}
																	}
																}			
															]
														},
														productItemGrid													
													]
												}
											]										
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																
															formPanel.submitForm({
																preSubmit: function(data) {
																
																	var referralModel = {
																		referralProgram: data,
																		referralProducts: []
																	};
																																		
																	//construct product items
																	productItems.forEach(function(item){		
																		if (item.referralCancelDate === '') {
																			delete item.referralCancelDate;
																		}																																			
																		referralModel.referralProducts.push(item);																		
																	});
																
																	return referralModel;
																},
																actualCall: function(data) {
																	return BillingService.getReferralService().saveReferralProgram(data, record ? true : false);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Referral Program', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	if (formPanel.successCallback) {
																		formPanel.successCallback();
																	}
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);	
						
						var actionRefreshItems = function() {
							productItemGrid.activeItem = null;
							productItemGrid.items = productItems.slice(0);				
						};
						
						var actionAddProduct = function() {
						
							var addItemWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Add Product Item',
								icon: 'lumo:edit',
								width: '75%',
								height: 300,
								listeners: {
									ready: function() {						
										addItemWin.show();
																				
										var itemFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [																								
														{
															tag: 'vaadin-combo-box',											
															itemid: 'product',
															label: 'Products', 
															name: 'product',
															required: true,															
															'item-value-path': 'code',
															'item-label-path': 'description',
															postinit: function(combo) {
																
																BillingService.getProductService().getProducts().then(function(dataResponse){
																	//format the code
																	var products = [];
																	dataResponse.data.forEach(function(product){																																				
																		products.push({
																			code: product.productCode,
																			description: product.productName
																		});
																	});
																	products.sort(function(a, b){
																		return a.description.localeCompare(b.description);
																	});
																	
																	combo.items = products;
																});
															}
														},	
														{
															tag: 'vaadin-date-picker',
															label: 'Effective Date',
															required: true,
															name: 'referralEffDate',
															maxlength: 16
														},										
														{
															tag: 'vaadin-date-picker',
															label: 'Cancel Date',
															name: 'referralCancelDate',											
															maxlength: 255
														},
														{
															tag: 'vaadin-number-field',
															label: 'Reward Amount',
															name: 'referralRewardAmt',
															required: true,															
															min: 0,
															max: 9999999
														},
														{
															tag: 'vaadin-number-field',
															label: 'Duration Months',
															name: 'referralDurationAmt',
															required: true,															
															min: 0,
															max: 999
														},
														{
															tag: 'vaadin-combo-box',											
															label: 'Reward Type', 
															name: 'referralRewardType',
															required: true,											
															'item-value-path': 'code',
															'item-label-path': 'description',
															postinit: function(combo) {
																Service.getLookupService().getLookupValues('ReferralRewardType').then(function(data){
																	combo.items = data;
																});
															}
														},														
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function() {		
																			var data = itemFormPanel.getData();
																			
																			var productCB = ElementUtil.query(itemFormPanel, 'product');
																			var productValue = productCB.selectedItem;
																			data.productName = productValue.description;
																			data.productCode = productValue.code;								
																			data.referralDurationUom = 'M';
																			data.currencyCode = 'USD';
																			
																			productItems.push(data);
																			actionRefreshItems();
																			addItemWin.close();
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			//cancel
																			addItemWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]

										});
										addItemWin.addToContentElement(itemFormPanel);	
										
									}
								}
							});
							
						};
						
						var actionRemoveProduct = function(product) {
							var newItems = [];
							productItems.forEach(function(item){
								if (!(item.productCode === product.productCode)) {
									newItems.push(item);
								}
							});	
							productItems = newItems;
							actionRefreshItems();
						};
						
						//edit
						if (record) {
							productItems = record.referralProducts;								
							actionRefreshItems();		
							formPanel.load(record.referralProgram);	
						}
						
					}
				}
			});
		
						
		};
		
		var actionCancel = function(record) {
			var summary = window.DL.MessageUtil.ellipseText(record.referralProgram.referralProgramCode, 20);
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Cancel',
				message: 'Are you sure you want to cancel ' + summary + ' referral program?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Canceling...');													
							
							BillingService.getReferralService().deleteReferralProgram(record.referralProgram.referralProgramCode).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Canceled: ' + summary, {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});				
		};		

	}
	
};
customElements.define('dl-referralprogram-grid', ReferralProgramGrid);
